import { BI_TYPE_BIRTHDAY_GIFT, REWARD_TYPES } from 'ai/constants/superchat';

const isBirthdayGift = product => product.bi_type?.toLowerCase() === BI_TYPE_BIRTHDAY_GIFT;

const isRewardType = product => Boolean(product.bi_type);

const hasRewardProducts = products => products?.length > 0 && products.every(isRewardType);

const getRewardType = products => {
    if (products.every(isBirthdayGift)) {
        return REWARD_TYPES.BIRTHDAY;
    }

    return REWARD_TYPES.REWARDS_BAZAAR;
};

export {
    isBirthdayGift, isRewardType, hasRewardProducts, getRewardType
};
